module.exports = __webpack_public_path__ + "img/support_cn.99d45e2.jpg";